import PropTypes from 'prop-types';
import SelectField from '../../Form/SelectField/SelectField';
import Icon from '../Icon/Icon';
import { isEmpty } from 'lodash';
import languageEnums from './languageEnums';

const defaultField = {
  name: 'language',
  initialValue: 'en',
  value : 'en',
};

const LanguageSelector = ({
  displayLabelInSelectedLanguage = false,
  field = defaultField,
  registerField = null,
  disabled = false,
  theme = { width: '20rem' },
  options = [],
  appContext = '',
  translationsNewLanguageFlag = false,
  intlProvider = {},
  onChange,
}) => {
  let languageOptions;
  switch (appContext) {
    case 'shares':
      languageOptions = languageEnums.languages.filter(language => language.shares);
      break;
    case 'widgets':
      languageOptions = languageEnums.languages.filter(language => language.widgets);
      break;
    case 'consent':
    default:
      languageOptions = translationsNewLanguageFlag ? languageEnums.languages.filter(language => language.consent) : languageEnums.languages.filter(language => language.consent && !language.new);
  }

  const label = !isEmpty(intlProvider) && displayLabelInSelectedLanguage ? (
    intlProvider.formatMessage({
      id: 'RqjsZm',
      defaultMessage: 'Language',
      description: 'language',
    })
  ) : 'Language';

  return (
    <div style={theme} className="flex items-center space-x-2 space-y-2 h-8">
      <Icon className="mt-3" icon="Globe" />
      <SelectField
        className="language-select-field"
        id="language-selector"
        name="language-selector"
        field={field}
        registerField={registerField}
        clearable={false}
        label={`${label}:`}
        options={!isEmpty(options) ? options : languageOptions}
        onChange={language => onChange(language, field, registerField)}
        labelKey="display_name"
        valueKey="value"
        labelClassName="language-select-field-label normal-case text-sm -mt-1"
        searchThreshold={0.1}
        inline
        disabled_prop={disabled}
      />
    </div>
  );
};

LanguageSelector.propTypes = {
  displayLabelInSelectedLanguage: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  field: PropTypes.object,
  registerField: PropTypes.func,
  disabled: PropTypes.bool,
  theme: PropTypes.object,
  options: PropTypes.array,
  appContext: PropTypes.string,
  translationsNewLanguageFlag: PropTypes.bool,
  intlProvider: PropTypes.shape({
    locale: PropTypes.string,
    messages: PropTypes.object,
    formatMessage: PropTypes.func,
  }),
};

export default LanguageSelector;
